import { render, staticRenderFns } from "./LeaveType-Setting.vue?vue&type=template&id=df01618a&scoped=true"
import script from "./LeaveType-Setting.vue?vue&type=script&lang=js"
export * from "./LeaveType-Setting.vue?vue&type=script&lang=js"
import style0 from "./LeaveType-Setting.vue?vue&type=style&index=0&id=df01618a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df01618a",
  null
  
)

export default component.exports